import {
	database, SettingKey, TableName,
} from 'utils/database';
import {
	useBasisService,
} from 'services';
import {
	toastError, toastSuccess,
} from 'utils/toast';
import {
	getErrorMessageFromStatus,
} from 'utils/error';
import {
	FeedbackModel,
} from '../models/feedback.model';
import {
	getSessionId,
} from '../utils/logrocket';
import {
	useLiveQuery,
} from 'dexie-react-hooks';
import {
	useEffect,
	useState,
} from 'react';

const endpoint = 'api/customer-service/feedback';

export const useFeedbackService = () => { // Model

	const {
		error: [error, setError],
		http,
		baseUrl,
	} = useBasisService<FeedbackModel[]>(database.feedback);
	const registeredPhoneNumber = useLiveQuery(() => database.table(TableName.SETTINGS).get(SettingKey.PHONE));
	const [phoneNumber, setPhoneNumber] = useState<string>(registeredPhoneNumber);
	const [isPosting, setIsPosting] = useState<boolean>(false);

	useEffect(() => {
		setPhoneNumber(registeredPhoneNumber?.value);
	}, [registeredPhoneNumber?.value]);

	const send = async (message: string, allowContact: boolean) => {
		const sessionId = getSessionId();

		if (!sessionId || !phoneNumber) {
			toastError('Kunne ikke oppdatere transport', 'Kunne ikke finne session ID');
			return Promise.reject();
		}
		const feedback = new FeedbackModel(sessionId, message, allowContact, phoneNumber);

		setIsPosting(true);
		return new Promise<void>((resolve, reject) => {
			http.post<void>(endpoint, feedback, {
				baseUrl,
				timeout: 0,
			})
				.then(() => {
					toastSuccess('Tilbakemeldingen er sendt', 'Takk for tilbakemeldingen! Vi ser på den så fort vi kan.');
					resolve();
				})
				.catch(error => {
					setError(error);
					toastError('Vi kunne ikke sende inn tilbakemeldingen', getErrorMessageFromStatus(error.status));
					reject();
				})
				.finally(() => setIsPosting(false));
		});
	};

	return {
		database,
		phoneNumber,
		setPhoneNumber,
		isPosting,
		error,
		send,
	};
};